<template>
  <div class="DatePickerTimeClock">
    <div class="hoursColumn">
      <Button text size="small" severity="secondary" @click="incrementHours()">
        <i class="pi pi-chevron-up"></i>
      </Button>
      <div class="hours" @click="emit('showHours')">
        {{ hours12 }}
      </div>
      <Button text size="small" severity="secondary" @click="decrementHours()">
        <i class="pi pi-chevron-down"></i>
      </Button>
    </div>
    <div class="colon">
      :
    </div>
    <div class="minutesColumn">
      <Button text size="small" severity="secondary" @click="incrementMinutes()">
        <i class="pi pi-chevron-up"></i>
      </Button>
      <div class="minutes" @click="emit('showMinutes')">
        {{ padStart(minutes, 2, "0") }}
      </div>
      <Button text size="small" severity="secondary" @click="decrementMinutes()">
        <i class="pi pi-chevron-down"></i>
      </Button>
    </div>
    <div class="periodColumn">
      <Button severity="secondary" @click="togglePeriod()">
        {{ isAm ? 'AM' : 'PM' }}
      </Button>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { padStart } from "./utility.js";

let props = defineProps([
  "date"
]);

let emit = defineEmits([
  "showHours",
  "showMinutes"
]);

let date = defineModel("date");

let hours = computed(() => {
  return date.value.getUTCHours();
});

let hours12 = computed(() => {
  let mod12 = hours.value % 12;
  return (mod12 == 0) ? 12 : mod12;
});

let minutes = computed(() => {
  return date.value.getUTCMinutes();
});

let isAm = computed(() => {
  return date.value.getUTCHours() < 12;
});

function incrementHours() {
  let newHours = hours.value + 1;
  if (newHours >= 24) newHours = 0;

  let newDate = new Date(date.value);
  newDate.setUTCHours(newHours);
  date.value = newDate;
}

function decrementHours() {
  let newHours = hours.value - 1;
  if (newHours < 0) newHours = 23;

  let newDate = new Date(date.value);
  newDate.setUTCHours(newHours);
  date.value = newDate;
}

function incrementMinutes() {
  let newMinutes = minutes.value + 1;
  if (newMinutes >= 60) newMinutes = 0;

  let newDate = new Date(date.value);
  newDate.setUTCMinutes(newMinutes);
  date.value = newDate;
}

function decrementMinutes() {
  let newMinutes = minutes.value - 1;
  if (newMinutes < 0) newMinutes = 59;

  let newDate = new Date(date.value);
  newDate.setUTCMinutes(newMinutes);
  date.value = newDate;
}

function togglePeriod() {
  let newDate = new Date(date.value);
  let newHours = (hours.value + 12) % 24;
  newDate.setUTCHours(newHours);
  date.value = newDate;
}
</script>

<style scoped>
.DatePickerTimeClock {
  display: flex;
  align-items: center;
  justify-content: center;
}
.hoursColumn, .minutesColumn, .periodColumn {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.periodColumn {
  padding: 20px;
}
.hours, .minutes, .colon {
  padding: 20px;
  font-size: large;
}
:deep(.p-button) {
  border: 0;
}
</style>